import React from 'react';

const AircraftTypeRating = () => {
  const ratings = [
    { name: 'Airbus A320 Family', img:'author-23.png', features: ['Full Flight Simulator', 'EASA Approved', 'DGCA Approved'] },
    { name: 'BOEING B-737', img:'Boeing_full_logo.png', features: ['Full Flight Simulator', 'EASA Approved', 'DGCA Approved'] },
    { name: 'ATR 72-600', img:'Atr.png', features: ['Full Flight Simulator', 'EASA Approved', 'DGCA Approved'] },
  ];

  return (
    <section className="py-5 bg-light aircraft-rating" id="type-rating">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Aircraft Type Rating Courses</h2>
          <p className="text-muted">Get certified on specific aircraft types with our comprehensive type rating programs</p>
        </div>
<div className="row g-4">
  {ratings.map((rating, index) => (
    <div key={index} className="col-md-4">
      <div className="card h-100 border-0 shadow-sm rating-card">
        <div className="card-body d-flex flex-column">

          {/* IMAGE */}
          <div className="rating-img text-center mb-3">
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/${rating.img}`}
              alt={rating.name}
            />
          </div>

          {/* TEXT CONTENT */}
          <div className="rating-content mb-3">
            <h5 className="aircraft-title ">{rating.name}</h5>

           <div className="aircraft-list">
            {rating.features.map((feature, i) => (
              <div className="aircraft-item" key={i}>
                <i className={`fas ${i === 0 ? "fa-plane" : "fa-check-circle"}`}></i>
                <span>{feature}</span>
              </div>
            ))}
            </div>
          </div>

          {/* BUTTON (sticks to bottom) */}
          <button className="btn btn-primary mt-auto">
            Learn More
          </button>

        </div>
      </div>
    </div>
  ))}
</div>

      </div>
    </section>
  );
};

export default AircraftTypeRating;